import { getDefaultCurrency } from 'store/state';

export interface IFormatCurrecyOptions {
  suffix?: string;
  fractionDigits?: number;
  length?: number;
  minimumFractionDigits?: number;
}

export const formatCurrency = (number = 0, options?: IFormatCurrecyOptions) => {
  const currency = number
    .toLocaleString('en-US', {
      minimumFractionDigits:
        options?.minimumFractionDigits ?? options?.fractionDigits ?? 2,
      maximumFractionDigits: options?.fractionDigits ?? 2,
    })
    .replaceAll(',', ' ')
    .replace('.', ',')
    .concat(
      ` ${options?.suffix?.trim() ?? getDefaultCurrency()?.currencyCode ?? ''}`
    );

  if (options?.length && currency.length < options.length) {
    const missingSpaces = options.length - currency.length;
    return `${'  '.repeat(missingSpaces)}${currency}`;
  }

  return currency;
};
